gsap.registerPlugin(ScrollTrigger);

const setupScrollAnimation = () => {
  const scrollSections = document.querySelectorAll('.type_mv');

  // matchMediaを使用してPCのみに適用
  ScrollTrigger.matchMedia({

    // PCサイズ（1024px以上）の場合の処理
    "(min-width: 769px)": function () {

      scrollSections.forEach((section) => {
        const bgImg = section.querySelector('.type_img');
        if (!bgImg) return;

        // 初期状態のセット
        gsap.set(bgImg, {
          clipPath: 'polygon(25% 25%, 75% 25%, 75% 75%, 25% 75%)'
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: 'top top',
            end: '+=100%',
            scrub: 1,
            pin: true,
            anticipatePin: 1,
            invalidateOnRefresh: true
          }
        });

        tl.to(bgImg, {
          clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
          ease: 'none'
        });
      });

      // この関数内で作成されたScrollTriggerは、
      // 画面幅が1024px未満になると自動的に kill（削除）されます。
    },

    // オプション：スマホ時にスタイルをリセットしたい場合
    "(max-width: 768px)": function () {
      // 必要であればスマホ用の処理をここに記述
    }

  });
};

window.addEventListener('load', setupScrollAnimation);